import React from 'react';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {FormCustomTabContentWrapperProps} from '@src/@types/components/Form';

export default function DefaultTabContentWrapper<Model extends IEmptyModel = IEmptyModel>(
        props: FormCustomTabContentWrapperProps<Model>
) {
    return <>{props.children}</>;
}
